export const environment = {
    production: true,
    https: true,
    appUrl: '/',
    apiUrl: '/api',
    signalUrl: '/signalr'
};
